import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { type LayoutProps, PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl = '/[locale]/fundraising-events/[slug]/sharing-options?utm_campaign&utm_medium'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl.bind(null, true))
export type SharingOptionsPageProps = PageProps<typeof pageUrl>
export type SharingOptionsLayoutProps = LayoutProps<typeof pageUrl>
